/* eslint-disable import/no-extraneous-dependencies */
import { NgModule } from '@angular/core';
import {
   bgLocale,
   csLocale,
   defineLocale,
   deLocale,
   esLocale,
   itLocale,
   ptBrLocale,
   skLocale,
   slLocale,
} from 'ngx-bootstrap/chronos';
import { enGbLocale, frLocale, huLocale, plLocale, roLocale } from 'ngx-bootstrap/locale';
import { elLocale } from './greek-locale';

// eslint-disable-next-line no-shadow
export enum Locales {
   en = 'en',
   hu = 'hu',
   pl = 'pl',
   ro = 'ro',
   fr = 'fr',
   cs = 'cs',
   de = 'de',
   it = 'it',
   es = 'es',
   pt = 'pt',
   bg = 'bg',
   sl = 'sl',
   sk = 'sk',
   el = 'el', // greek
}

export function defineLocales(): void {
   defineLocale(Locales.en.toLocaleLowerCase(), enGbLocale);
   defineLocale(Locales.hu.toLocaleLowerCase(), huLocale);
   defineLocale(Locales.pl.toLocaleLowerCase(), plLocale);
   defineLocale(Locales.ro.toLocaleLowerCase(), roLocale);
   defineLocale(Locales.fr.toLocaleLowerCase(), frLocale);
   defineLocale(Locales.cs.toLocaleLowerCase(), csLocale);
   defineLocale(Locales.de.toLocaleLowerCase(), deLocale);
   defineLocale(Locales.it.toLocaleLowerCase(), itLocale);
   defineLocale(Locales.es.toLocaleLowerCase(), esLocale);
   defineLocale(Locales.pt.toLocaleLowerCase(), ptBrLocale);
   defineLocale(Locales.bg.toLocaleLowerCase(), bgLocale);
   defineLocale(Locales.sl.toLocaleLowerCase(), slLocale);
   defineLocale(Locales.sk.toLocaleLowerCase(), skLocale);
   defineLocale(Locales.el.toLocaleLowerCase(), elLocale);
}

@NgModule({
   declarations: [],
   imports: [],
   exports: [],
})
export class LocaleModule {
   constructor() {
      defineLocales();
   }
}
